export default "__VITE_ASSET__CAdC9GDC__"